<template>
    <div class="panel-body">
        <div class="col-xs-12">
            <div class="form-group">
                <label>Term</label>
                <select 
                	@change="getVideos"
                	class="form-control"               	
                	v-model="selectedTerm">                		
                	<option v-for="term in terms" :value="term.id">
                		{{term.name}}
                	</option>
            	</select>
            </div>
            <div v-if="groups" class="groups">            	
            	<div v-for="(videos, id) in groups">
            		<h4 class="cursor-pointer" 
            			@click="selectedGroup === id ? selectedGroup = null : selectedGroup = id">
                   		{{determineGroupLabel(videos[0])}}
                   		<i class="fa fa-caret-down" v-if="selectedGroup===id"></i>
                    	<i v-else class="fa fa-caret-right"></i>
            			
            		</h4>
            		<div v-if="selectedGroup === id">
            			<table class="table table-striped table-bordered ">
            				<thead>
            					<tr>
            						<th>Week</th>
            						<th>Duration</th>
            						<th>Created</th>
            						<th class="text-center">Link</th>
            					</tr>
            				</thead>
            				<tbody>
            					<tr v-for="video in videos">
            						<td>
										{{video.week}}										
									</td>
									<td>
										{{(video.duration / 60).toFixed(1)}} min
									</td>
									<td>
										{{video.createdAt | shortDate}}									
									</td>
									<td class="text-center">
										<a :href="video.url" target="_blank">
											<video width="100" >
													<source :src="video.url" type="video/mp4">
											</video>
										</a>
									</td>
            					</tr>
            				</tbody>
            			</table>
            			
            		</div>
            	</div>
            </div>
        </div>
    </div>
</template>
<script>
import terms from './../../services/terms';
import introVideos from './../../services/intro-videos';
import _ from 'lodash';

export default {
    data() {
        return {
            terms: null,
            selectedTerm: null,
            groups: null,
            selectedGroup:null
        }
    },
    components: {

    },
    created() {
        const now = new Date();
        terms.get(this).then((response) => {
            this.terms = response.data.terms.filter(t => new Date(t.startDate) < now && t.type !== 'mentorship' && !t.name.toLowerCase().includes('challenge'))
            this.selectedTerm = this.terms[0].id;
            this.getVideos();
        });
    },
    mounted() {

    },
    methods: {
    	determineGroupLabel(video) {    		
    		const group = video.groups[0];
    		const groupLabel = group.label.toLowerCase();
    		if (groupLabel.includes('morning') || groupLabel.includes('afternoon') || groupLabel.includes('evening')) {
    			// these groups were not named according to the group naming convention; 
    			// we need to get the name of the supervisor for the group and include the name in the label.    			
    			
    			return video.user.firstName + ' ' + video.user.lastName + ' - ' + group.label;
    		} else {
    			return video.groups[0].label
    		}
    	},
    	getVideos() {
    		introVideos.get(this, this.selectedTerm).then((response) => {
				
				const videos = response.data.videos.filter(v => v.groups && v.groups.length > 0 && v.groups[0].id)
				const groupedVideos = _.groupBy(videos, (v)=>{
					return v.groups[0].id
				});
				for (const key in groupedVideos) {
					if (groupedVideos.hasOwnProperty(key)) {
						const element = groupedVideos[key];
						element.sort((a,b)=>{
							return a.week - b.week;
						})
					}
				}
				this.groups = groupedVideos;

			});
    	}
    },
    computed: {

    }
}

</script>

<style lang="scss" scoped>
table {
	table-layout:fixed
}
.panel-body {
    min-height: 500px;
}

.groups {
	h4 {
		margin-bottom:2rem;
	}
}

</style>



// WEBPACK FOOTER //
// DirectorIntroVideos.vue?4fa25c52